
import axios from 'axios';

export default {

	pre_insercion(p_email, p_usuario, p_sistema) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_mantencion.pre_insercion",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_sistema": p_sistema,
				  })
			})
	},

    recuperar(p_email, p_usuario, p_sistema, p_criterio) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_mantencion.recuperar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_sistema": p_sistema,
					"p_criterio":p_criterio
				  })
			})
    },
    
	modificar(p_email, p_usuario, p_sistema, p_criterio, p_valor, p_tpdato) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_mantencion.modificar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_sistema" : p_sistema,
					"p_criterio": p_criterio,
					"p_valor": p_valor,
					"p_tpdato": p_tpdato
				  })
			})
    }

}